/* Product page on a phone: three things that made it unusable, each undone without touching the
   theme's own scripts.
   1. The bulk-order list (one stepper row per variant, often 14+) was 4,000 px of scrolling between
      the description and the form. It is now a folded panel with a count; the buy box above already
      covers the single-variant order.
   2. The Overview prose (a generic essay on some kits) pushed the parts and data down a screen and a
      half. It is clamped with "Read more".
   3. The tab bar scrolls sideways with nothing to say so. The active tab is centred when chosen and
      the bar fades where more tabs wait. */
(() => {
  const phone = window.matchMedia('(max-width: 749px)');

  /* 1 · bulk-order list */
  const foldOrderList = () => {
    const section = document.querySelector('[id$="__quick-order-list"]');
    if (!section || section.dataset.dnFolded) return;
    const rows = section.querySelectorAll('tbody tr, .quick-order-list__row').length;
    const variants = new Set([...section.querySelectorAll('.variant-item__name')].map((e) => e.textContent.trim())).size;
    const count = variants || Math.round(rows / 3) || rows;
    section.dataset.dnFolded = '1';
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'dn-fold__toggle'; button.setAttribute('aria-expanded', 'false');
    button.innerHTML = '<span>Order several sizes at once' + (count ? ' <small>' + count + ' variants</small>' : '') + '</span><svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m4 6 4 4 4-4"/></svg>';
    section.insertBefore(button, section.firstChild);
    section.classList.add('dn-fold');
    const apply = () => { const open = !phone.matches; section.classList.toggle('is-open', open); button.setAttribute('aria-expanded', String(open)); };
    button.addEventListener('click', () => { const open = !section.classList.contains('is-open'); section.classList.toggle('is-open', open); button.setAttribute('aria-expanded', String(open)); });
    phone.addEventListener('change', apply); apply();
  };

  /* 2 · overview prose */
  const clampOverview = () => {
    document.querySelectorAll('.dnd__overview').forEach((box) => {
      if (box.dataset.dnClamp) return;
      if (!phone.matches || !box.offsetHeight) return;
      box.dataset.dnClamp = '1';
      if (box.scrollHeight < 340) return;
      box.classList.add('is-clamped');
      const more = document.createElement('button');
      more.type = 'button'; more.className = 'dn-more'; more.textContent = 'Read more';
      more.addEventListener('click', () => { const open = box.classList.toggle('is-clamped') === false; more.textContent = open ? 'Show less' : 'Read more'; });
      box.after(more);
    });
  };

  /* 3 · tab bar */
  const tabBar = () => {
    document.querySelectorAll('.dnd__bar').forEach((bar) => {
      if (bar.dataset.dnHint) return;
      bar.dataset.dnHint = '1';
      const update = () => {
        const max = bar.scrollWidth - bar.clientWidth;
        bar.classList.toggle('can-right', max > 4 && bar.scrollLeft < max - 4);
        bar.classList.toggle('can-left', bar.scrollLeft > 4);
      };
      bar.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      bar.addEventListener('click', (e) => {
        const tab = e.target.closest('.dnd__tab');
        if (tab) setTimeout(() => { const left = tab.offsetLeft - (bar.clientWidth - tab.offsetWidth) / 2; bar.scrollTo({ left, behavior: 'smooth' }); }, 30);
      });
      update();
      setTimeout(update, 400);
    });
  };

  const run = () => { foldOrderList(); clampOverview(); tabBar(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', () => { run(); setTimeout(run, 600); });
  phone.addEventListener('change', clampOverview);
})();
